import { useMemo } from 'react';
import { apiClient } from '../../../api/client';
import { url as apiUrl } from '../../../api';
import { COFFEE_API_BASE } from '../../coffee_card_web/api/paths';
import { useLocalCache, UseLocalCacheResult } from '../../coffee_shops/utils/swrCache';

const url = apiUrl || process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001';

export interface ChainAggregateByType {
    coffeeKey: string;
    avgRating: number;
    count: number;
}

export interface ChainAggregateTopShop {
    shopId: string;
    name: string;
    avgRating: number;
    ratingCount: number;
}

export interface ChainAggregate {
    avgRating: number;
    ratingCount: number;
    byCoffeeType: ChainAggregateByType[];
    topShops: ChainAggregateTopShop[];
}

export function useChainAggregate(chainId: string | undefined): UseLocalCacheResult<ChainAggregate> {
    const key = chainId ? `coffee_chain_aggregate_${chainId}` : null;

    const fetcher = useMemo(
        () => async () => {
            const response = await apiClient.get<ChainAggregate>(
                `${url}${COFFEE_API_BASE}/chains/${chainId}/rating-aggregate`
            );
            return response.data;
        },
        [chainId]
    );

    return useLocalCache<ChainAggregate>(key, 5 * 60 * 1000, fetcher);
}
